import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { getSaleAdvanceReceipt } from '@/service/operate/budgetReport';
export default function useSaleAdvanceReceipt(params) {
  var saleAdvanceReceipt = ref({
    sjyshj: 0,
    slyshj: 0,
    styshj: 0,
    yssrzhj: 0
  });
  var getSaleAdvanceReceiptAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSaleAdvanceReceipt(params.value);
          case 2:
            data = _context.sent;
            saleAdvanceReceipt.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getSaleAdvanceReceiptAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var saleAdvanceReceiptTotal = computed(function () {
    return [{
      num: saleAdvanceReceipt.value.yssrzhj,
      desc: '销售预收总金额/元'
    }];
  });
  var saleAdvanceReceiptData = computed(function () {
    return {
      pieData: [{
        name: '骨料',
        value: saleAdvanceReceipt.value.slyshj
      }, {
        name: '商砼',
        value: saleAdvanceReceipt.value.styshj
      }, {
        name: '砂浆',
        value: saleAdvanceReceipt.value.sjyshj
      }].filter(function (item) {
        return item.value;
      }),
      unit: '元',
      customTooltip: true,
      tooltipFormatter: function tooltipFormatter(params) {
        return "\n          <div >\n            <div class=\"flex align-start\">\n              <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n              <div>\n                <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                <div>\n                 <span style=\"font-size: 12px;\">").concat(params.value, "\u5143</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          ");
      }
    };
  });
  return [saleAdvanceReceiptTotal, saleAdvanceReceiptData, getSaleAdvanceReceiptAsync];
}